import { OneBlinkAppsError } from '@oneblink/apps-react'
import { FormTypes } from '@oneblink/types'
import { HTTPError, postRequest } from '../lib/http'

export function getOBApi(apiId: string, apiEnv: string): string {
  if (apiEnv.toLowerCase() === 'prod') {
    return apiId
  }
  const arr = apiId.split('.')
  arr[0] += `-${apiEnv}`
  return arr.join('.')
}

export default async function serverValidation(
  serverValidation: FormTypes.Form['serverValidation'],
  submission: Record<string, unknown>,
  form: FormTypes.Form,
  isDraft?: boolean,
) {
  if (!serverValidation) return

  console.log(
    'form requires server validation prior to submission. validating now...',
  )

  const url =
    serverValidation.type === 'CALLBACK'
      ? serverValidation.configuration.url
      : `https://${getOBApi(
          serverValidation.configuration.apiId,
          serverValidation.configuration.apiEnvironment,
        )}${serverValidation.configuration.apiEnvironmentRoute}`

  try {
    await postRequest({
      url,
      resource: { submission, isDraft, formId: form.id },
      addAuthHeaders: form.isAuthenticated,
    })
  } catch (e) {
    if (e instanceof HTTPError) {
      throw new OneBlinkAppsError(e.message, { httpStatusCode: e.status })
    }

    throw e
  }
}
